import { z } from 'zod/v4';
export const EntropySourceSchema = z.enum([
    'ANU_QRNG',
    'WEB_CRYPTO',
    'CSPRNG_LOCAL',
    'WP_HOSTED_CSPRNG',
]);
export const EntropyAuditSchema = z.object({
    source: EntropySourceSchema,
    session_hash: z.string().min(1),
    shannon_entropy: z.number().nonnegative(),
    shannon_max: z.number().positive(),
    shannon_ratio: z.number().min(0).max(1),
    baker_rounds: z.number().int().nonnegative(),
    von_neumann_active: z.boolean(),
    entropy_bytes_hex: z.string().min(2),
    timestamp: z.number().int().nonnegative(),
    lunar_phase: z.string().min(1).nullable(),
    solar_decan: z.string().min(1).nullable(),
    audit_mode: z.enum(['client', 'server']),
    verifiable: z.boolean(),
});
export const EntropyAuditJsonSchema = z.toJSONSchema(EntropyAuditSchema);
//# sourceMappingURL=audit.schema.js.map